import React, { Component, useEffect, useState } from "react";
import { postData, getData, patchData, deleteData } from '../../util/Fetch';
import { Button } from "reactstrap";
import swal from "sweetalert";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';

const EditProfile = () => {

    const [editData, setEditData] = React.useState({
        Name:'',
        OriPassword:'',
        NewPassword:'',
        CheckPassword:'',
    });

    const handleChange = e => {
        setEditData({ ...editData, [e.currentTarget.id]: e.currentTarget.value });
    };

    const beforeSubmitName =() => {
        if(!editData.Name){
            return false;
        }
    }

    const initialPassword = () => {
        setEditData({...editData, 
            OriPassword:'',
            NewPassword:'',
            CheckPassword:'',
        })
    } 

    const handleSubmitName = () => {
        if(beforeSubmitName() === false){
            swal("請重新嘗試", "請確實填入姓名", "warning");
            return;
        }
        initialPassword();
        postData('stylist', editData).then(res => {
            if(res === true){
                swal("更新成功", "設定已順利更新", "success");
            }
        })
    }

    const beforeSubmitPassword =() => {
        if(!editData.OriPassword || !editData.NewPassword || !editData.CheckPassword){
            return false;
        }
    }

    const handleSubmitPassword = () => {
        if(beforeSubmitPassword() === false){
            swal("請重新嘗試", "請確實填入密碼", "warning");
            return;
        }
        setEditData({...editData, 
            Name:'',
        })
        postData('stylist', { ...editData, Name: '' }).then(res => {
            if(res === true){
                swal("更新成功", "設定已順利更新", "success");
            }
            else{
                swal("更新失敗", "請重新設定", "error");
            }
            initialPassword();
        })
    }

    return (
        <div>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="Name" value={editData.Name} label="設計師暱稱" onChange={handleChange} required variant="outlined" type="text" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <Button variant="contained" onClick={handleSubmitName}>更新名稱</Button>
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="OriPassword" value={editData.OriPassword} label="原本密碼" onChange={handleChange} required variant="outlined" type="password" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="NewPassword" value={editData.NewPassword} label="新密碼" onChange={handleChange} required variant="outlined" type="password" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <TextField id="CheckPassword" value={editData.CheckPassword} label="確認新密碼" onChange={handleChange} required variant="outlined" type="password" />
                </FormControl>
            </Stack>
            <Stack spacing={2} sx={{ width: '100%', marginTop: '2%' }}>
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <Button variant="contained" onClick={handleSubmitPassword}>更新密碼</Button>
                </FormControl>
            </Stack>
        </div>
        
    );
}

export default EditProfile
